export { default } from "./useGetHiddenContent";
